import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { updateTimeRange } from 'custom_hooks/data_hooks/time_ranges/useTimeRange';
import { TimeRangeTableCellProps } from 'pages/Settings/TimeRanges/TimeRanges';

const errorMessage = 'Unable to save setting for time range.';

export function TimeRangeIsGlobalCell({ rowData, onChange }: TimeRangeTableCellProps) {
    const onSave = async (newValue: boolean | undefined) => {
        if (newValue === undefined) {
            return errorMessage;
        }
        try {
            await updateTimeRange(rowData, { IsGlobal: newValue });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <SwitchInlineEditor
            ariaLabel={`${rowData.Name} add automatically`}
            onConfirm={onSave}
            value={rowData.IsGlobal}
        />
    );
}
